export default "__VITE_ASSET__9b9316c1__"